module.exports = __webpack_public_path__ + "img/menu-hair-8.c61d4a5e.jpg";